import LDatePicker from './LDatePicker.vue'

export default (Vue) => {
  Vue.component(LDatePicker.name, LDatePicker)
}
